module.exports = __webpack_public_path__ + "static/media/icon-thoughts.f034fdf9.svg";